import React from 'react';

export const Waves = ({topSide}) => ( 
  <svg width="102" height="56" viewBox="0 0 102 56" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: topSide && "rotate(180deg)"}}>
    <rect width="102" height="56" rx="4" fill="#D9D9D9" />
    <mask id="mask0_237_11021" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="102" height="56">
      <rect width="102" height="56" rx="4" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_237_11021)">
      <path d="M27.3182 29.8769C32.2482 30.8563 37.0218 32.6118 41.9382 33.6766C48.9413 35.1943 56.2343 35.2859 63.2264 33.712C70.0213 32.1861 77.0669 28.4645 83.7811 26.5738C89.7353 24.8963 96.2362 24.2056 102 26.3014V56H0V32.5174C8.70958 28.9906 18.1571 28.0774 27.3182 29.8769Z" fill="#8A8A8A" />
    </g>
  </svg>
)


export const WaveLayers = ({topSide}) => (
  <svg width="102" height="56" viewBox="0 0 102 56" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: topSide || "rotate(180deg)"}}>
    <rect x="102" y="56" width="102" height="56" rx="4" transform="rotate(180 102 56)" fill="#D9D9D9" />
    <mask id="mask0_237_11084" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="102" height="56">
     <rect x="102" y="56" width="102" height="56" rx="4" transform="rotate(180 102 56)" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_237_11084)">
      <path opacity="0.4" d="M102 24V27.5614C97.9378 29.2693 93.1948 30.0364 88.57 29.7156C82.5894 29.3024 76.982 27.1528 70.992 26.8305C64.7156 26.495 58.4511 28.1291 52.445 29.5432C46.557 30.9281 40.6895 31.4574 34.646 30.5495C31.5732 30.0879 28.7088 29.177 25.7678 28.2922C17.8934 25.9234 7.395 22.9006 -1.07288e-06 28.0368V24H102Z" fill="#8A8A8A" />
      <path opacity="0.6" d="M102 24V25.2937C100.895 27.021 99.6506 28.6526 97.9464 29.8956C93.5501 33.1048 87.975 33.0827 82.9107 31.4936C80.2629 30.6631 77.803 29.3604 75.2887 28.237C71.8105 26.6823 68.0867 24.473 64.1682 24.1727C61.0861 23.9394 58.1417 24.9435 55.7872 26.7551C53.0868 28.8327 50.49 31.8283 46.9786 32.7284C43.5412 33.6113 40.0639 32.181 36.8526 30.7417C33.6413 29.3023 30.464 27.5504 26.9144 27.219C21.8374 26.7404 17.2856 29.0912 12.5579 30.3972C9.9909 31.1058 7.5429 30.902 5.15525 29.7835C3.2487 28.8924 1.07525 27.5799 -1.07288e-06 25.7544V24H102Z" fill="#8A8A8A" />
      <path d="M102 0L102 24.4335C89.256 28.543 75.3024 29.4916 61.5545 27.2779C57.8995 26.6896 54.3949 25.7287 50.7076 25.2405C45.6926 24.576 41.1468 26.183 36.635 27.9663C31.626 29.9459 26.69 31.3335 21.148 30.93C13.7929 30.391 6.4889 27.4103 0 24.3996V0H102Z" fill="#8A8A8A" />
    </g>
  </svg>
)

export const Ramp = ({topSide}) => (
  <svg width="102" height="56" viewBox="0 0 102 56" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: topSide && "rotate(180deg)"}}>
    <rect width="102" height="56" rx="4" fill="#D9D9D9" />
    <mask id="mask0_237_11056" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="102" height="56">
      <rect width="102" height="56" rx="4" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_237_11056)">
      <rect x="-13.5397" y="55.6465" width="130" height="40" transform="rotate(-15 -13.5397 55.6465)" fill="#8A8A8A" />
    </g>
  </svg>
)

export const RampLayers = ({topSide}) => (
  <svg width="102" height="56" viewBox="0 0 102 56" fill="none" xmlns="http://www.w3.org/2000/svg" style={{transform: topSide && "rotate(180deg)"}}>
    <rect width="102" height="56" rx="4" fill="#D9D9D9" />
    <mask id="mask0_237_11045" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="102" height="56">
      <rect width="102" height="56" rx="4" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_237_11045)">
      <rect x="-13.5397" y="46.6465" width="130" height="40" transform="rotate(-15 -13.5397 46.6465)" fill="#CACACA" />
      <rect x="-13.5397" y="49.6465" width="130" height="40" transform="rotate(-15 -13.5397 49.6465)" fill="#B0B0B0" />
      <rect x="-13.5397" y="52.6465" width="130" height="40" transform="rotate(-15 -13.5397 52.6465)" fill="#9A9A9A" />
      <rect x="-13.5397" y="55.6465" width="130" height="40" transform="rotate(-15 -13.5397 55.6465)" fill="#8A8A8A" />
    </g>
  </svg>
)

const CarouselSlides = (props) => {
  return [
  {
    value: "wave",
    image: <Waves {...props} />,
    name: "editPanel.backgroundEffect.carousel.wave"
  },
  {
    value: "waveLayers",
    image: <WaveLayers {...props} />,
    name: "editPanel.backgroundEffect.carousel.waveLayers"
  },
  {
    value: "ramp",
    image: <Ramp {...props} />,
    name: "editPanel.backgroundEffect.carousel.ramp"
  },
  {
    value: "rampLayers",
    image: <RampLayers {...props} />,
    name: "editPanel.backgroundEffect.carousel.rampLayers"
  }
]
}
export default CarouselSlides;
